import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { UploadBulkProducts } from "pages/Products/UploadBulkProducts/UploadBulkProducts"
import React, { useState } from "react"
import { AddProductStepOne } from "./AddProductStepOne"
import { useTranslation } from "react-i18next"

interface StepContentProps {
  step: number
  onAlert: (data: { error: boolean; text: string | React.ReactNode }) => void
  onClose: () => void
  handleGoToStepTwo: (type?: string) => void
  handleGoToStepFirst: (type?: string) => void
  hideBack: boolean
}

const StepContent: React.FC<StepContentProps> = ({
  step,
  onAlert,
  onClose,
  handleGoToStepTwo,
  handleGoToStepFirst,
  hideBack,
}) => {
  if (step === 1) return <AddProductStepOne handleGoToStepTwo={handleGoToStepTwo} />

  return (
    <UploadBulkProducts
      onAlert={onAlert}
      backHandler={() => handleGoToStepFirst()}
      onClose={onClose}
      hideBack={hideBack}
    />
  )
}

interface AddProductsModalProps {
  onAlert: (data: { error: boolean; text: string | React.ReactNode }) => void
  onClose: () => void
  isOpen: boolean
  initialStep?: 1 | 2
  initialType?: "bulk" | "from-store"
}

export const AddProductsModal: React.FC<AddProductsModalProps> = ({
  onAlert,
  onClose,
  isOpen,
  initialStep,
  initialType,
}) => {
  const [step, setStep] = useState(initialStep ?? 1)
  const { t } = useTranslation()
  const [selectedModalType, setSelectedModalType] = useState<string>(initialType ?? "bulk")

  const handleGoToStepTwo = (type?: string) => {
    if (type) setSelectedModalType(type)
    setStep(2)
  }
  const handleGoToStepFirst = (type?: string) => {
    if (type) setSelectedModalType(type)
    setStep(1)
  }

  const isBulkView = step === 2 && selectedModalType === "bulk"
  const hideBack = initialStep === 2
  const title = isBulkView
    ? t("productsPage.uploadProductList")
    : t("addProductsModal.selectProduct")
  const description = isBulkView
    ? t("uploadBulkProducts.saveTimeByAddingProducts")
    : t("addProductStepOne.title", { defaultValue: "Choose how you want to add products" })

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg" data-testid="add-products-modal">
        <DialogHeader>
          <DialogTitle data-testid="add-products-modal-title">{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <StepContent
          step={step}
          onAlert={onAlert}
          onClose={onClose}
          handleGoToStepTwo={handleGoToStepTwo}
          handleGoToStepFirst={handleGoToStepFirst}
          hideBack={hideBack}
        />
      </DialogContent>
    </Dialog>
  )
}
